export class InventoryResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "discoveredTime",
            "baseName": "discoveredTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "latestSnapshotTime",
            "baseName": "latestSnapshotTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "oldestSnapshotTime",
            "baseName": "oldestSnapshotTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "backupStatus",
            "baseName": "backupStatus",
            "type": "BackupStatus",
            "format": ""
        },
        {
            "name": "statusProperties",
            "baseName": "statusProperties",
            "type": "StatusProperties",
            "format": ""
        },
        {
            "name": "actionRequiredDetails",
            "baseName": "actionRequiredDetails",
            "type": "ActionRequiredDetails",
            "format": ""
        },
        {
            "name": "threatDetection",
            "baseName": "threatDetection",
            "type": "SecurityAssignmentStatus",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "classifications",
            "baseName": "classifications",
            "type": "Classifications",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountDisplayName",
            "baseName": "accountDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotStorage",
            "baseName": "snapshotStorage",
            "type": "SnapshotStorage",
            "format": ""
        },
        {
            "name": "sourceStorage",
            "baseName": "sourceStorage",
            "type": "SourceStorage",
            "format": ""
        },
        {
            "name": "controlViolationCounts",
            "baseName": "controlViolationCounts",
            "type": "ControlViolations",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "sourceAccountTags",
            "baseName": "sourceAccountTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceProperties",
            "baseName": "resourceProperties",
            "type": "ResourceProperties",
            "format": ""
        },
        {
            "name": "backupPolicies",
            "baseName": "backupPolicies",
            "type": "Array<InventoryBackupPolicy>",
            "format": ""
        },
        {
            "name": "dlsgPolicy",
            "baseName": "dlsgPolicy",
            "type": "DlsgPolicy",
            "format": ""
        },
        {
            "name": "vaults",
            "baseName": "vaults",
            "type": "Array<InventoryVault>",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "InventoryResourceMetadata",
            "format": ""
        },
        {
            "name": "securityScans",
            "baseName": "securityScans",
            "type": "Array<SecurityScan>",
            "format": ""
        },
        {
            "name": "resourceGroupId",
            "baseName": "resourceGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "quota",
            "baseName": "quota",
            "type": "ResourceQuota",
            "format": ""
        },
        {
            "name": "relatedGlobalDbClusters",
            "baseName": "relatedGlobalDbClusters",
            "type": "Array<RelatedGlobalDbCluster>",
            "format": ""
        },
        {
            "name": "clusterOldestSnapshotTime",
            "baseName": "clusterOldestSnapshotTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "clusterLatestSnapshotTime",
            "baseName": "clusterLatestSnapshotTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "issuesCount",
            "baseName": "issuesCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "logSources",
            "baseName": "logSources",
            "type": "Array<LogSource>",
            "format": ""
        },
        {
            "name": "restoreTemplateId",
            "baseName": "restoreTemplateId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "restoreTemplateName",
            "baseName": "restoreTemplateName",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastDataClassificationTime",
            "baseName": "lastDataClassificationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "encryptionType",
            "baseName": "encryptionType",
            "type": "Array<EncryptionType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryResource.attributeTypeMap;
    }
    constructor() {
    }
}
